export function buildVipClass ({ taskinfo, user_list }) {
  let item = getUserVip(taskinfo.uin, user_list)
  return item ? getVipClassItem(item) : ''
}

function getUserVip (vipid, list) {
  let item = null
  if (vipid && list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].uin === vipid) {
        item = list[i]
        break
      }
    }
  }
  return item
}

function getVipClassItem (item) {
  let vip_class = ''
  if (item.isVip) {
    if (item.isAnn) {
      vip_class += ' u_icon_vip_year'
    } else {
      vip_class += ' u_icon_vip'
    }
  } else {
    vip_class += ' u_icon_vip_lost'
  }
  if (item.vipLevel) {
    vip_class += [' vip_', item.vipLevel].join('')
  }
  return vip_class
}
